import { useEffect, useState } from "react";
import { api, formatNaira, formatDate } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Chip, stageChip } from "@/components/Chip";

// Deals view = lightweight view over leads (won/proposal/qualified stages) with aggregate revenue
export default function Deals() {
  const [leads, setLeads] = useState([]);
  useEffect(() => { api.get("/leads").then(r => setLeads(r.data)); }, []);

  const won = leads.filter(l => l.stage === "won").reduce((s, l) => s + Number(l.value || 0), 0);
  const inFlight = leads.filter(l => ["qualified", "proposal"].includes(l.stage)).reduce((s, l) => s + Number(l.value || 0), 0);
  const pipeline = leads.reduce((s, l) => s + Number(l.value || 0), 0);

  return (
    <div className="space-y-6">
      <PageHeader title="Deals" subtitle="Every opportunity across the pipeline" />

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="kpi-card"><div className="text-xs uppercase tracking-wider text-slate-500">Won (closed)</div><div className="font-heading font-bold text-2xl text-emerald-600 num">{formatNaira(won)}</div></div>
        <div className="kpi-card"><div className="text-xs uppercase tracking-wider text-slate-500">In flight</div><div className="font-heading font-bold text-2xl text-slate-900 num">{formatNaira(inFlight)}</div></div>
        <div className="kpi-card"><div className="text-xs uppercase tracking-wider text-slate-500">Total pipeline</div><div className="font-heading font-bold text-2xl text-slate-900 num">{formatNaira(pipeline)}</div></div>
      </div>

      <div className="table-wrap">
        <table className="w-full text-sm">
          <thead className="table-head">
            <tr>
              <th className="text-left px-4 py-3">Deal</th>
              <th className="text-left px-4 py-3">Contact</th>
              <th className="text-left px-4 py-3">Unit</th>
              <th className="text-left px-4 py-3">Stage</th>
              <th className="text-right px-4 py-3">Value</th>
              <th className="text-left px-4 py-3">Expected close</th>
            </tr>
          </thead>
          <tbody>
            {leads.map(l => (
              <tr key={l.id} className="row">
                <td className="px-4 py-3 font-medium text-slate-800">{l.title}</td>
                <td className="px-4 py-3 text-slate-600">{l.contact_name}<div className="text-xs text-slate-400">{l.company}</div></td>
                <td className="px-4 py-3"><Chip>{l.business_unit}</Chip></td>
                <td className="px-4 py-3"><Chip variant={stageChip(l.stage)}>{l.stage}</Chip></td>
                <td className="px-4 py-3 text-right font-heading font-semibold num">{formatNaira(l.value)}</td>
                <td className="px-4 py-3 text-xs text-slate-500">{formatDate(l.expected_close)}</td>
              </tr>
            ))}
            {leads.length === 0 && <tr><td colSpan={6} className="text-center py-12 text-slate-500 text-sm">No deals yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
